
  import { controls } from "../controls";
  
  
  const glsearch = {
    label: "Ledger Search",
    pageLabel: "Ledger Search",
    starting: true,
    url: "glsearch",
    pageType: "history",
    formState: { checked: "view" },
    formActions: { edit: { allow: true }, delete: { allow: true } },
    // "Address.",
    filter:[
        ...controls.displayText({tab:"filter",label:"Account Group Like",width:"col-sm-2"}),
        ...controls.text({tab: "filter",name:"account_group_like",width:"col-sm-4"}),

        ...controls.displayText({tab:"filter",label:"Ledger Group Like",width:"col-sm-2"}),
        ...controls.text({tab: "filter",name:"ledger_group_like",width:"col-sm-4"}),
        ...controls.displayText({tab:"filter",label:"Search String",width:"col-sm-2"}),
        ...controls.text({tab: "filter",name:"search_string",width:"col-sm-4"}),
        ...controls.displayText({tab:"filter",label: "Product Attach",width:"col-sm-2"}),
        ...controls.select({tab: "filter",name: "product_attach",width:"col-sm-4",placeHolder: "Select", defaultValue:"" ,
        options:[{
          label: "All",
          value: "all"
        },
        {
          label: "True",
          value: "True"
        },
        {
          label: "False",
          value: "False"
        }
    ]}),
    
    ],
    form:[],
    history: {
        perPage: 10,
        reportHeader: "Products",
        pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
        displayColumns: [
          {
            Header: "Ledger Code",
            accessor: "code",
            width: 150
          },
          {
            Header: "Ref Code",
            accessor: "refcode",
          },
          {
            Header: "Name",
            accessor: "description",
          },
          {
            Header: "guid",
            show:false,
            accessor: "guid",
          }
        ]
      }
  }

  export default glsearch;